"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTypes = exports.ValidationTypes = exports.TextTypeVariants = exports.ExcelDisplayTypes = exports.DataSourceTypes = void 0;
var DataSourceTypes;
(function (DataSourceTypes) {
    DataSourceTypes["users"] = "users";
    DataSourceTypes["usersWithTags"] = "usersWithTags";
    DataSourceTypes["parent"] = "parent";
    DataSourceTypes["timezones"] = "timezones";
    DataSourceTypes["element"] = "element";
    DataSourceTypes["events"] = "events";
    DataSourceTypes["days"] = "days";
    DataSourceTypes["timeDifference"] = "timeDifference";
    DataSourceTypes["listOfValues"] = "listOfValues";
    DataSourceTypes["complex"] = "complex";
})(DataSourceTypes || (exports.DataSourceTypes = DataSourceTypes = {}));
var ExcelDisplayTypes;
(function (ExcelDisplayTypes) {
    ExcelDisplayTypes["table"] = "table";
    ExcelDisplayTypes["linnear"] = "linnear";
})(ExcelDisplayTypes || (exports.ExcelDisplayTypes = ExcelDisplayTypes = {}));
var TextTypeVariants;
(function (TextTypeVariants) {
    TextTypeVariants["standart"] = "standart";
    TextTypeVariants["textArea"] = "textArea";
})(TextTypeVariants || (exports.TextTypeVariants = TextTypeVariants = {}));
var ValidationTypes;
(function (ValidationTypes) {
    ValidationTypes["required"] = "required";
    ValidationTypes["number"] = "number";
    ValidationTypes["date"] = "date";
    ValidationTypes["regex"] = "regex";
    ValidationTypes["minLength"] = "minLength";
    ValidationTypes["maxLength"] = "maxLength";
    ValidationTypes["beforeDate"] = "beforeDate";
    ValidationTypes["afterDate"] = "afterDate";
    ValidationTypes["url"] = "url";
    ValidationTypes["warning"] = "warning";
})(ValidationTypes || (exports.ValidationTypes = ValidationTypes = {}));
var FieldTypes;
(function (FieldTypes) {
    FieldTypes["text"] = "text";
    FieldTypes["group"] = "group";
    FieldTypes["date"] = "date";
    FieldTypes["list"] = "list";
    FieldTypes["select"] = "select";
    FieldTypes["time"] = "time";
    FieldTypes["dateTime"] = "dateTime";
    FieldTypes["costingTable"] = "costingTable";
    FieldTypes["flightButton"] = "flightButton";
    FieldTypes["imageSelection"] = "imageSelection";
    FieldTypes["uploadDocument"] = "uploadDocument";
    FieldTypes["addressLookup"] = "addressLookup";
    FieldTypes["costInput"] = "costInput";
})(FieldTypes || (exports.FieldTypes = FieldTypes = {}));
